import type { DirectusDriver } from '@/types/directus-types'
import { fakeNoData } from './bad-placeholder-helpers'

const collectionName = 'Driver'
const query = {
  fields: ['id', 'Name', 'Driving', 'ProfilePic', 'Bio'],
}

/**
 * Fetches an individual driver record based on the passed id.
 *
 * @param driverId the id of the users driver record
 * @returns a user `DriverData` object if successful. Undefined if not.
 */
export async function fetchDriverData(driverId: number | string): Promise<DirectusDriver | undefined> {
  return await fakeNoData()
}
